import React from 'react'
import styled from 'styled-components'

import PageOperation from './PageOperation'
import { PreviewIcon } from './PreviewIcon'
import { SelectRole } from './SelectRole'

interface PageToolMobileProps {}

const SCxContainer = styled.div`
    position: absolute;
    top: 0;
    left: 12px;
    right: 12px;
    height: 48px;
    display: flex;
    justify-content: space-between;
    font-size: var(--font-size-normal);
    align-items: center;
    z-index: 1;
`

export const PageTool: React.FunctionComponent<PageToolMobileProps> = props => {
    return (
        <SCxContainer data-ignore-click-away>
            <PageOperation />
            <PreviewIcon hoverColor="var(--color-gray-200)" />
            <SelectRole />
            {/* <RedoUndo /> */}
        </SCxContainer>
    )
}
